import { render } from "./ItemListDocenciaImpartida.vue?vue&type=template&id=0598c95c&scoped=true"
import script from "./ItemListDocenciaImpartida.vue?vue&type=script&lang=js"
export * from "./ItemListDocenciaImpartida.vue?vue&type=script&lang=js"

import "./ItemListDocenciaImpartida.vue?vue&type=style&index=0&id=0598c95c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0598c95c"]])

export default __exports__